var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 88C55.6695 88 66.8611 83.3643 75.1127 75.1127C83.3643 66.8611 88 55.6695 88 44C88 32.3305 83.3643 21.1389 75.1127 12.8873C66.8611 4.6357 55.6695 0 44 0C32.3305 0 21.1389 4.6357 12.8873 12.8873C4.6357 21.1389 0 32.3305 0 44C0 55.6695 4.6357 66.8611 12.8873 75.1127C21.1389 83.3643 32.3305 88 44 88ZM63.4219 35.9219L41.4219 57.9219C39.8063 59.5375 37.1938 59.5375 35.5953 57.9219L24.5953 46.9219C22.9797 45.3063 22.9797 42.6938 24.5953 41.0953C26.2109 39.4969 28.8234 39.4797 30.4219 41.0953L38.5 49.1734L57.5781 30.0781C59.1937 28.4625 61.8062 28.4625 63.4047 30.0781C65.0031 31.6938 65.0203 34.3062 63.4047 35.9047L63.4219 35.9219Z",
    fill: "#01A93A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.feb31a6ba3e4f0d601272e6ca0579557.svg";
export { ForwardRef as ReactComponent };